import Phaser from 'phaser';

export default class Enemy {
    constructor(scene, x, y) {
        this.scene = scene;
        this.startPos = { x, y };
        this.isDead = false;

        // Create visual with more detail
        this.sprite = scene.add.rectangle(x, y, 40, 40, 0xff3333);
        this.sprite.setStrokeStyle(3, 0xcc0000);

        // Evil eyes
        this.leftEye = scene.add.circle(x - 10, y - 5, 6, 0xffffff);
        this.rightEye = scene.add.circle(x + 10, y - 5, 6, 0xffffff);
        this.leftPupil = scene.add.circle(x - 8, y - 5, 3, 0x000000);
        this.rightPupil = scene.add.circle(x + 12, y - 5, 3, 0x000000);

        // Angry eyebrows
        this.leftBrow = scene.add.rectangle(x - 10, y - 14, 14, 3, 0x000000);
        this.rightBrow = scene.add.rectangle(x + 10, y - 14, 14, 3, 0x000000);
        this.leftBrow.setAngle(-20);
        this.rightBrow.setAngle(20);

        // Shadow
        this.shadow = scene.add.ellipse(x, y + 25, 35, 10, 0x000000, 0.3);

        // Physics
        const { Bodies } = Phaser.Physics.Matter.Matter;
        const enemyBody = Bodies.rectangle(x, y, 40, 40, {
            isStatic: false,
            friction: 0.05,
            frictionAir: 0.01,
            density: 0.002,            // Lighter - won't push box as much
            label: 'enemy'
        });

        scene.matter.add.gameObject(this.sprite, enemyBody);
        this.sprite.setFixedRotation();
        this.sprite.enemyObject = this;

        // Patrol behavior
        this.moveDir = 1;
        this.speed = 1.8;
        this.walkDist = 120;

        // Animation state
        this.bounceTimer = 0;
    }

    update() {
        if (this.isDead || !this.sprite.active) return;

        // Simple Patrol
        if (this.sprite.x > this.startPos.x + this.walkDist) {
            this.moveDir = -1;
        } else if (this.sprite.x < this.startPos.x - this.walkDist) {
            this.moveDir = 1;
        }

        this.sprite.setVelocityX(this.moveDir * this.speed);

        // Update face position to follow body
        const x = this.sprite.x;
        const y = this.sprite.y;

        this.leftEye.x = x - 10;
        this.leftEye.y = y - 5;
        this.rightEye.x = x + 10;
        this.rightEye.y = y - 5;

        // Pupils look in movement direction
        const pupilOffset = this.moveDir * 2;
        this.leftPupil.x = x - 10 + pupilOffset;
        this.leftPupil.y = y - 5;
        this.rightPupil.x = x + 10 + pupilOffset;
        this.rightPupil.y = y - 5;

        this.leftBrow.x = x - 10;
        this.leftBrow.y = y - 14;
        this.rightBrow.x = x + 10;
        this.rightBrow.y = y - 14;

        this.shadow.x = x;
        this.shadow.y = y + 25;

        // Bounce animation
        this.bounceTimer += 0.15;
        const bounce = Math.sin(this.bounceTimer) * 2;
        this.sprite.setScale(1 + Math.abs(bounce) * 0.02, 1 - Math.abs(bounce) * 0.02);
    }

    kill() {
        if (this.isDead) return;
        this.isDead = true;
        this.destroyVisuals();
    }

    /**
     * Destroy all visual elements safely
     */
    destroyVisuals() {
        const visuals = [
            this.sprite,
            this.leftEye,
            this.rightEye,
            this.leftPupil,
            this.rightPupil,
            this.leftBrow,
            this.rightBrow,
            this.shadow
        ];

        visuals.forEach(visual => {
            if (visual && visual.destroy && !visual.destroyed) {
                visual.destroy();
            }
        });

        // Clear references
        this.sprite = null;
        this.leftEye = null;
        this.rightEye = null;
        this.leftPupil = null;
        this.rightPupil = null;
        this.leftBrow = null;
        this.rightBrow = null;
        this.shadow = null;
    }

    /**
     * Full cleanup - called when scene ends
     */
    destroy() {
        this.isDead = true;
        this.destroyVisuals();
    }
}
